import { UserDetails } from 'pages/Login/Login.types';

export const getPublisherIdByPortalId = (portalId: string, userDetails?: UserDetails | null): string | undefined => {
  if (!userDetails) {
    return undefined;
  }
  
  const portals = userDetails.portals;
  if (!portals) {
    return undefined;
  }
  
  const store = portals.find(p => p.portalId === portalId)?.stores?.[0];
  return store?.storeId;
};

export const SLUG_SANITIZE_REGEX = /[^\p{L}0-9]+|(?<=-)-+|^-+|-+$/gu;

export const sanitizeSlug = (str: string) => {
  return str.toLowerCase().replace(SLUG_SANITIZE_REGEX, (match, offset, string) => 
    offset === string.length - match.length ? '' : '-'
  );
};